
import KayakAdInline from '@/components/KayakAdInline.vue'
import FlightsListItemSkeleton from '@/components/FlightsListItemSkeleton.vue'

const parseInlineAds = (unparsed) => {
  return unparsed.map((ad, index) => ({ ...ad, id: `kayak-${index}`, component: 'KayakAdInline', props: { item: ad } }))
}

export default {
  components: {
    KayakAdInline,
    FlightsListItemSkeleton
  },
  computed: {
    inlineAds () {
      const ads = this.$store.state.inlineAds
      if (!ads || !ads.length) return []
      return parseInlineAds(ads)
    },
    roundtrip () {
      return this.$store.state.flightsSearchFormData?.roundtrip !== false
    },
    placeholderRenderItems () {
      const skeletons = Array.from({ length: 4 }, (_, index) => ({
        id: `skeleton-${index}`,
        component: 'FlightsListItemSkeleton',
        props: { roundtrip: this.roundtrip }
      }))
      const ads = this.inlineAds || []

      return [...ads, ...skeletons]
    }
  }
}
